// questions_a.js
// 消化管 (A01〜A07) 全問データ
// App.jsの形式に合わせた形式:
//   q  : 問題文（___が空欄）
//   a  : 正解（スペース区切りで複数キーワード、判定用）
//   n  : 補足メモ・解説（currentQ.nで表示）
//   s  : セクション（A01〜A07）
//   ch : チャプター名

export const QUESTIONS_U = [

   // U01 せん妄
{
  q: '①せん妄とは，【動揺】する【意識混濁】に加え，幻覚（特に幻【視】）や【妄想】，精神運動興奮，不安などがみられる状態をいう．その他，睡眠覚醒リズムの変化や【見当識障害】，【健忘】などを認める．症状の【日内変動】が大きく，【夜間】に悪化しやすい．代表的なものに【夜間】せん妄，【術後】せん妄，【ICU】せん妄などが挙げられる．',
  s: 'U02', ch: 'せん妄',
},
{
  q: '②せん妄の三大因子',
  s: 'U02', ch: 'せん妄',
  type: 'indent',
  rows: [
    { level: 0, text: '・準備因子：高齢，【認知症】，【脳血管】障害など' },
    { level: 0, text: '・促進因子：環境変化（【入院】，【ICU】など），【睡眠妨害】因子（夜間照明など），不動化（【臥床安静】，【拘束】など），疼痛，心理的ストレスなど' },
    { level: 0, text: '・直接因子：【ベンゾジアゼピン系】などの薬物，AIUEOTIPSなどの身体的疾患，手術など' },
  ]
},
{
  q: '③せん妄の非薬物療法として，主に促進・直接因子を軽減し取り除くことが重要である．例えば，適切な【睡眠】リズムの設定による【昼夜逆転】の防止であったり，家族との【面会】による【ストレス】の軽減などを行う．ICU患者の場合，可能な限り【一般】病床へ戻すとよい．その他，疼痛ケアや処方の整理，身体疾患の治療などが挙げられる．',
  s: 'U02', ch: 'せん妄',
},
{
  q: '④せん妄の薬物療法では，抗精神病薬（【リスペリドン】，【クエチアピン】，【ハロペリドール】など）が用いられる．',
  s: 'U02', ch: 'せん妄',
},
{
  q: '⑤【ベンゾジアゼピン系】はせん妄を増悪させるため禁忌であるが，アルコール多飲者の急激な断酒により生じる【振戦】せん妄に対しては治療として用いられる．',
  s: 'U02', ch: 'せん妄',
},

// U01 身体因性精神障害
{
  q: '①脳の器質性疾患から生じるものを【器質】性精神障害，脳以外の全身性の疾患や障害によって生じるものを【症状】性精神障害という．しかし，症状性と器質性を明確に線引きすることは困難である．',
  s: 'U02', ch: '身体因性精神障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・器質性：【脳血管障害】，頭部外傷，脳炎，てんかん，【神経変性疾患】など' },
    { level: 0, text: '・症状性：内分泌疾患（【甲状腺機能異常】など），代謝疾患（肝性脳症，低血糖など），膠原病（SLEなど），月経・妊娠（PMS，産褥精神病など），医原性（【ステロイド】，IFNなど）' },
  ]
},
{
  q: '②身体因性精神障害の急性期には【意識障害】をきたしやすく，基礎疾患の治癒とともに症状は消失しうる．慢性期では【認知機能低下】や【記憶】障害をきたしやすく，感情障害，（意識障害を伴わない）幻覚や妄想など多彩な症状をみる．',
  s: 'U02', ch: '身体因性精神障害',
}, 
// U03 統合失調症
{
  q: '①統合失調症では幻覚妄想を代表とする【陽】性症状や，感情の平坦化や意欲低下などの【陰】性症状を認める．',
  s: 'U03', ch: '統合失調症',
},
{
  q: 'シュナイダーの一級症状',
  s: 'U03', ch: '統合失調症',
  type: 'indent',
  rows: [
    { level: 0, text: '・【考想化声】（自分の考えが声として聞こえてくる）' },
    { level: 0, text: '・対話性の幻聴（2人以上が話し合う幻聴が聞こえる）' },
    { level: 0, text: '・【自己の行為】に随伴して【口出し】する形の幻聴（「〇〇するな」と批判される）' },
    { level: 0, text: '・【妄想知覚】（知覚に対して特殊な意味付けをしてそれを確信する）' },
    { level: 0, text: '・【考想伝播】（自分の考えが他人に伝わる）' },
    { level: 0, text: '・させられ体験（自分の行動が他人に操られている）' },
    { level: 0, text: '・【思考奪取】（自分の考えが抜き取られる）' },
  ]
},
{
  q: 'ブロイラーの4A（陰性症状）',
  s: 'U03', ch: '統合失調症',
  type: 'indent',
  rows: [
    { level: 0, text: '・【連合弛緩】（Association）… 考えのつながりが失われる' },
    { level: 0, text: '・【感情鈍麻】（Affection）… 自然な感情反応が失われる' },
    { level: 0, text: '・【自閉】（Autism）… 物理的・精神的な引きこもり' },
    { level: 0, text: '・【両価】性（Ambivalence）… 相反する感情が同時に生じる' },
  ]
},
{
  q: '②妄想の分類',
  s: 'U03', ch: '統合失調症',
  type: 'indent',
  rows: [
    { level: 0, text: '・一次妄想' },
    { level: 1, text: '・妄想【気分】… 何か不気味で大変なことが起こりそうだという不安' },
    { level: 1, text: '・妄想【知覚】… 知覚に対して特殊な意味付けをして，それを確信する' },
    { level: 1, text: '・妄想【着想】… 正常な知覚に対して，突然了解不能な意味付けをする' },
    { level: 0, text: '・二次妄想：統合失調症では【被害】妄想が生じやすい' },
  ]
},
{
  q: '③統合失調症の思考障害のうち，思考過程の異常として，【連合弛緩】，【減裂思考】，【思考途絶】などがある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '④統合失調症における知覚の障害として，【幻聴】と体感幻覚がある．統合失調症では幻視はまれである．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑤統合失調症における自我の障害として，【考想伝播】，【思考吹入】，【思考奪取】，【させられ体験】などがある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑥統合失調症における感情の障害として，【感情鈍麻】，【両価性】などがある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑧統合失調症における意欲・行動の障害として，無為，自閉，【独語】，空笑，【緊張病症候群】がある．【緊張病症候群】では，【興奮】や【カタレプシー】，反響動作，反響言語，拒絶症などが認められる．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑨統合失調症は【100】人に1人が罹患し，【10】代後半から【20】代前半に発症することが多い．遺伝負因の影響もある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑩統合失調症では中脳辺縁系のドパミン【増加】により陽性症状が，中脳皮質系のドパミン【低下】により陰性症状が起こると考えられている．（ドパミン仮説）',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑪統合失調症の治療薬',
  s: 'U03', ch: '統合失調症',
  type: 'indent',
  rows: [
    { level: 0, text: '・【定型抗精神病薬】(【ハロペリドール】など)：強力な【ドパミンD₂】受容体遮断作用を有する' },
    { level: 0, text: '・非定型抗精神病薬(【リスペリドン】，オランザピンなど)：ドパミンD₂受容体遮断作用＋セロトニン5-HT₂A受容体遮断作用，定型に比べて【錐体外路症状】などの副作用が少なく，【陰】性症状にも有効' },
    { level: 0, text: '・【非定型】抗精神病薬は薬物療法の第一選択' },
  ]
},
{
  q: '⑫抗精神病薬の副作用として，【錐体外路症状】（ジストニア，アカシジア，パーキンソニズム，遅発性ジスキネジアなど），【高プロラクチン】血症，悪性症候群，高脂血症，高【血糖】，無顆粒球症などがある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑬悪性症候群では，高熱，筋強剛，【ミオグロビン】尿をきたす．治療には大量補液や【ダントロレン】を用いる．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑭統合失調症の薬剤療法以外の治療は，【修正型電気けいれん】療法（mECT），精神療法（【生活技能訓練】や作業療法など），地域生活支援がある．',
  s: 'U03', ch: '統合失調症',
},
{
  q: '⑮統合失調症の予後良好因子には【高】年齢，【急性】発症，誘因が【ある】こと，病前の【社会適応】能力が高いこと，【緊張】型などがある．未治療期間が【長】いほど予後不良とされる．',
  s: 'U03', ch: '統合失調症',
},

// U03 妄想性障害
{
  q: '①妄想性障害は【中年期】以降に発症することが多く，【被害】妄想，心気妄想，誇大妄想のような単一もしくは相互に関連しあった一連の妄想は示すが，統合失調症症状（幻聴，させられ体験，感情鈍麻，連合弛緩など）は認め【ない】．治療は精神療法で，抗精神病薬を用いることもあるが反応は【不良】である．',
  s: 'U03', ch: '妄想性障害',
},
// U04 うつ病
{
  q: '①うつ病とは1回以上の大うつ病エピソードがあり，【躁病エピソード】を伴わないものである．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '②うつ病の発症の契機にはつらい出来事・状況のほか，【昇進】，【転居】，急激な負担の軽減などがある．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '③うつ病の中核症状である【抑うつ】気分，【疲労感】と【活動性】減少，【興味】と【喜び】の喪失に加え，自信の低下，罪悪感や集中困難，思考【制止】，【希死念慮】，食思不振・【体重減少】，睡眠障害，微小妄想（【貧困】妄想，【心気】妄想，【罪業】妄想）がみられる．【身体症状】を訴えることもある．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '④うつ病は【朝】のほうが症状が重く，日内変動を示すことがある．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '⑤うつ病の病前性格には【執着】性格，【メランコリー親和型】性格がある．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '⑥うつ病の薬物療法は抗うつ薬（SSRI，SNRI，NaSSA，三環系抗うつ薬など）が基本で，抗精神病薬や【抗不安】薬，【睡眠】薬を併用することがある．薬物療法以外では，【修正型電気けいれん】療法（mECT），精神療法（心理教育）がある．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '⑦修正型電気けいれん療法（mECT）は，精神・身体症状が重篤で迅速な改善が必要であったり，薬物療法で十分な効果が得られないような，重症の【うつ病】や【統合失調症】に有効である．副作用は，【健忘】，頭痛，嘔気，不整脈，高血圧などである．',
  s: 'U04', ch: 'うつ病',
},
{
  q: '⑧うつ病では十分な【休息】をとることが必要で，急性期の【励まし】や気晴らしの誘いは逆効果になることが多い．現在の状態や治療などについて丁寧に説明し，【希死念慮】の有無を質問し，自殺企図が切迫していたら入院を検討する．また，療養中は重大な決断をしないように伝える．',
  s: 'U04', ch: 'うつ病',
},

// U04 双極性障害
{
  q: '①双極性障害はうつ病エピソードと【躁病エピソード】を繰り返すものである．',
  s: 'U04', ch: '双極性障害',
},
{
  q: '②双極性障害における躁状態の症状',
  s: 'U04', ch: '双極性障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・爽快気分，【自尊心】肥大，行為【心迫】，【多弁】' },
    { level: 0, text: '・【観念奔逸】，【衝動】性亢進，不眠：【睡眠】欲求の減少' },
    { level: 0, text: '・注意散漫，【誇大】妄想' },
  ]
},
{
  q: '③双極性Ⅰ型障害はうつ状態+【激しい】躁状態を伴うもの，双極性Ⅱ型障害はうつ状態+【軽】躁状態を伴うものである．',
  s: 'U04', ch: '双極性障害',
},
{
  q: '④双極性障害の病前性格は【循環】気質である．',
  s: 'U04', ch: '双極性障害',
},
{
  q: '⑤双極性障害の治療は【気分安定】薬である【炭酸リチウム】，【バルプロ酸】，カルバマゼピン，ラモトリギンを用いる．抗精神病薬を併用することがある．抗うつ薬は【躁転】のリスクを上げるので注意する．',
  s: 'U04', ch: '双極性障害',
},
{
  q: '⑥炭酸リチウムとバルプロ酸には【催奇形性】の副作用，バルプロ酸とカルバマゼピンには【二分脊椎】の副作用があるため，【妊婦】には禁忌である．',
  s: 'U04', ch: '双極性障害',
},
// U05 不安障害
{
  q: '①【広場恐怖】症とは直ちに逃げたり助けを求めたりすることができない状況や場所を恐れ，回避するため時に外出も困難になる病態である．【パニック障害】の合併が多い．',
  s: 'U05', ch: '不安障害',
},
{
  q: '②【社交不安障害】は他人から注目されることを恐れ，社交場面を回避する病態である．比較的【少】人数の集団で起きやすく，低い自己評価や批判されることへの恐れと関係している．',
  s: 'U05', ch: '不安障害',
},
{
  q: '③パニック障害は誘因が【なく】突然予期せぬ【パニック発作】が反復して生じる．',
  s: 'U05', ch: '不安障害',
},
{
  q: '④パニック障害では【予期不安】を抱く．しばしば【広場恐怖】を伴う．',
  s: 'U05', ch: '不安障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・パニック発作：【動悸】，発汗，呼吸【促迫】，【胸】痛，【めまい】，悪心，窒息感，【死ぬこと】に対する恐怖' },
    { level: 0, text: '・【予期不安】：再び発作が起こるのではないかという不安' },
  ]
},
{
  q: '⑤全般性不安障害では，多数の出来事や対象への【過剰な不安】が慢性的に続く．苛立ちや集中困難，頭痛などを伴う．',
  s: 'U05', ch: '不安障害',
},
{
  q: '⑥不安障害の薬物治療の基本は【SSRI】を用いる．効果発現までに時間を要するため，急性期には発作時用に【抗不安】薬を処方することもある．薬物以外には【認知行動】療法や行動療法が有効である．',
  s: 'U05', ch: '不安障害',
},

// U05 強迫性障害
{
  q: '①強迫性障害とは【強迫観念】にとらわれ強い不安が生じ，不安を打ち消すために【強迫行為】を繰り返すものである．患者は【不合理】さに悩み，病識が【ある】．【Tourette症候群】との関連が指摘されている．',
  s: 'U05', ch: '強迫性障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・強迫【観念】：自分の意志に反する不合理な観念' },
    { level: 0, text: '・強迫【行為】：強迫観念を打ち消すために行う行為' },
  ]
},
{
  q: '②強迫性障害の治療は【SSRI】，三環系抗うつ薬，認知行動療法（曝露反応妨害法など）を行う．',
  s: 'U05', ch: '強迫性障害',
},

// U05 PTSD
{
  q: '①PTSDは生命や安全を脅かされるような著しく脅威的な体験（心的外傷）の後，数【週間】～数【ヶ月】の潜伏期間を経て発症する．他の精神疾患との合併や【自殺企図】も多い．',
  s: 'U05', ch: 'PTSD',
},
{
  q: '②PTSDの主要症状',
  s: 'U05', ch: 'PTSD',
  type: 'indent',
  rows: [
    { level: 0, text: '・再体験：【フラッシュバック】，【悪夢】' },
    { level: 0, text: '・【回避】：出来事の起きた場所や出来事を想起させる刺激を避ける' },
    { level: 0, text: '・麻痺：否定的な感情，アンヘドニア' },
    { level: 0, text: '・【過覚醒】：不眠，集中困難，易刺激性，過度の驚愕反応' },
  ]
},
{
  q: '③PTSDの薬物治療には【SSRI】を用いる．他，精神療法（曝露療法など）を行う．',
  s: 'U05', ch: 'PTSD',
},

// U05 適応障害
{
  q: '①適応障害とは生活の変化やストレスに対して起こる【抑うつ気分】である．【不安】などの情緒障害や苦悩により生活に支障をきたす．要因となる出来事が生じてから【1ヵ月】以内に発症し，通常【6ヵ月】以内に改善する．',
  s: 'U05', ch: '適応障害',
},
{
  q: '②適応障害の治療は【生活環境】の調整や認知行動療法を行う．',
  s: 'U05', ch: '適応障害',
},

// U05 解離性（転換性）障害
{
  q: '①解離性（転換性）障害ではストレスのかかる出来事により，過去の【記憶】，同一性，直接的感覚，【身体運動】などの統合が部分的もしくは完全に失われる．',
  s: 'U05', ch: '解離性（転換性）障害',
},
{
  q: '②解離性（転換性）障害の分類',
  s: 'U05', ch: '解離性（転換性）障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・【解離性】障害：記憶や同一性を失うもの' },
    { level: 1, text: '・記憶症状：【健忘】，【遁走】' },
    { level: 1, text: '・同一性症状：解離性同一性障害（【多重人格】）' },
    { level: 0, text: '・【転換性】障害：運動や感覚の統合を失うもの' },
    { level: 1, text: '・感覚症状：【らせん】状視野狭窄，知覚障害' },
    { level: 1, text: '・運動症状：失立失歩，【失声】，【けいれん】' },
  ]
},
{
  q: '③解離性（転換性）障害において，精神分析学では，根底に【疾病利得】があると考えられている．',
  s: 'U05', ch: '解離性（転換性）障害',
},
{
  q: '④解離性（転換性）障害は【精神療法】を行い，環境調整など【心理的要因】を取り除くことで症状が改善する．',
  s: 'U05', ch: '解離性（転換性）障害',
},

// U05 身体的苦痛症
{
  q: '①身体的苦痛症（身体症状症）とは，本人にとって苦痛に感じられる【身体症状】が出現し，それに【過度の注意】が向く病態．医療者に適切な説明を受けても安心できず，繰り返し医療機関を受診することがある．',
  s: 'U05', ch: '身体的苦痛症',
},
{
  q: '②身体的苦痛症（身体症状症）の治療は【SSRI】，【抗不安薬】などの薬物療法である．',
  s: 'U05', ch: '身体的苦痛症',
},
// U06 薬物依存
{
  q: '②【精神】依存は薬物摂取への強迫的な欲求がある状態で，そのために生活が乱される．依存性薬物の【全て】が精神依存をきたす．',
  s: 'U06', ch: '薬物依存',
},
{
  q: '③【身体】依存とは，薬物を摂取することで生理的な平衡状態を保っている状態で，断薬すると身体的な【離脱】症状が生じる．原因薬剤は【抑制】剤全般と【ニコチン】である．',
  s: 'U06', ch: '薬物依存',
},
{
  q: '④【耐性】とは，薬物を反復して乱用することで，薬物の効果が減少し摂取量が増えることである．【コカイン】と【大麻】は耐性を生じない．',
  s: 'U06', ch: '薬物依存',
},

// U06 アルコール
{
  q: '①酩酊の種類',
  s: 'U06', ch: 'アルコール使用障害',
  type: 'grouped',
  categories: [
    {
      label: '単純酩酊',
      groups: [{
        label: '普通の酩酊',
        rows: [
          { term: '', desc: '血中アルコール濃度の上昇に伴って【段階的】に進行する．' },
          { term: '', desc: '亜臨床期 → 発揚期 → 酩酊期 → 泥酔期 → 昏睡期' },
        ]
      }]
    },
    {
      label: '異常酩酊：【複雑酩酊】',
      groups: [{
        label: '【量】的異常',
        rows: [
          { term: '', desc: '広範な記憶欠損はない．いわゆる「酒乱」' },
          { term: '', desc: '比較的多量の飲酒後，【著しい興奮】が長く続く' },
        ]
      }]
    },
    {
      label: '異常酩酊：【病的酩酊】',
      groups: [{
        label: '【量】的異常＋【質】的異常',
        rows: [
          { term: '', desc: '【意識障害】，見当識障害，【健忘】を伴う' },
          { term: '', desc: '行動は了解不能である' },
          { term: '', desc: '飲酒量に関係なく出現する' },
        ]
      }]
    },
  ]
},
{
  q: '②アルコール依存症は，仕事や人間関係などを犠牲にしても飲酒する状態である．【肝】障害や【膵】炎，アルコール【心筋】症などの身体合併症を伴う．',
  s: 'U06', ch: 'アルコール使用障害',
},
{
  q: '③アルコール依存症ではビタミン【B1】欠乏を合併しやすい．',
  s: 'U06', ch: 'アルコール使用障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・【Wernicke脳症】：【意識】障害，【外眼筋】麻痺，【小脳失調】' },
    { level: 0, text: '・【Korsakoff症候群】：【記銘力】障害，【逆行性健忘】，【作話】' },
  ]
},
{
  q: '④アルコール依存症のスクリーニングには【CAGE質問票】を用いる．',
  s: 'U06', ch: 'アルコール使用障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・【Cut】down（減酒の必要性の自覚）' },
    { level: 0, text: '・【Annoyed】by criticism（飲酒の批判によるいらだち）' },
    { level: 0, text: '・【Guilty】feeling（飲酒に対する罪悪感）' },
    { level: 0, text: '・【Eye opener】（朝酒，迎え酒）' },
  ]
},
{
  q: '⑤アルコール依存症の治療は【断酒】が原則で，【認知行動療法】や自助グループ（AA，【断酒会】）への参加などの心理社会的介入が必要である．薬物療法では，抗酒薬であるジスルフィラムや【シアナミド】が用いられる．',
  s: 'U06', ch: 'アルコール使用障害',
},
{
  q: '⑥アルコール離脱症候群は長期飲酒歴のある人が断酒した際に生じる一連の症状で，断酒【数時間】後から生じる早期離脱症状と，断酒【1～3】日目に生じる後期離脱症状がある．',
  s: 'U06', ch: 'アルコール使用障害',
},
{
  q: '⑦アルコール離脱症候群の症状',
  s: 'U06', ch: 'アルコール使用障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・早期離脱症状：【不眠】，不安，【発汗】，全身【けいれん】など' },
    { level: 0, text: '・後期離脱症状：【意識】障害，【見当識】障害，幻覚（【小動物幻視】）や激しい自律神経症状，【振戦せん妄】' },
  ]
},
{
  q: '⑧アルコール離脱症状の予防として【ベンゾジアゼピン系】（【ジアゼパム】など）を用い，脱水・電解質補正の目的で，解糖系で消費されるビタミン【B1】を含む輸液を行う．',
  s: 'U06', ch: 'アルコール使用障害',
},

// U06 覚醒剤
{
  q: '①アンフェタミンやメタンフェタミンは【覚醒剤】と呼ばれ，アドレナリンやエフェドリンと類似の構造を持つ【中枢神経刺激薬】である．【メチルフェニデート】も中枢神経刺激薬の一種で，【ナルコレプシー】や【ADHD】に用いられる．',
  s: 'U06', ch: '覚醒剤',
},
{
  q: '②覚醒剤急性中毒では，覚醒剤使用時から【1】時間以内に【精神運動興奮】や多幸・万能感，多弁，不眠，血圧【上昇】などを生じ，薬効の消退に伴い【反跳】現象（無欲，疲労感，抑うつ気分）が数日間持続する．',
  s: 'U06', ch: '覚醒剤',
},
{
  q: '③覚醒剤依存症では明確な幻覚妄想はなく，情緒不安定や易怒性を認める．覚醒剤は【身体】依存は形成しないが，強い【精神】依存を生じる．また反復使用により【耐性】が生じ，使用量は次第に増加する．',
  s: 'U06', ch: '覚醒剤',
},
{
  q: '④覚醒剤精神病では覚醒剤の乱用により【統合失調】症様の症状（幻覚・妄想など）をきたす．使用中止で症状は消退するが，脳に【非可】逆的な過敏性が残る．【抗精神病薬】が有効である．',
  s: 'U06', ch: '覚醒剤',
  type: 'indent',
  rows: [
    { level: 0, text: '・【逆耐性】：少量の覚醒剤再使用により以前と同様の精神病症状が再燃すること' },
    { level: 0, text: '・【フラッシュバック】：ストレスなど非特異的な刺激によって，使用時のような精神症状をきたすこと' },
  ]
},

// U06 その他の薬物依存
{
  q: '①薬物依存の原因薬物は，抑制剤，興奮剤，幻覚剤の3つに大別される．',
  s: 'U06', ch: '薬物依存',
  type: 'grouped',
  categories: [
    {
      label: '抑制剤：麻薬(【モルヒネ】，【ヘロイン】，【コデイン】)',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【+】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '抑制剤：アルコール',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【+】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '抑制剤：バルビツール酸',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【+】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '抑制剤：ベンゾジアゼピン',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【−】〜【+】' },
        { term: '身体依存', desc: '【+】' },
        { term: '耐性', desc: '【−】〜【+】' },
      ]}]
    },
    {
      label: '興奮剤：覚醒剤(【アンフェタミン】，【メタンフェタミン】)',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '興奮剤：MDMA',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '興奮剤：コカイン',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】' },
        { term: '耐性', desc: '【−】' },
      ]}]
    },
    {
      label: '興奮剤：ニコチン',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】'},
        { term: '身体依存', desc: '【+】'},
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '幻覚剤：LSD',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】'},
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '幻覚剤：有機溶剤・シンナー',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】' },
        { term: '耐性', desc: '【+】' },
      ]}]
    },
    {
      label: '幻覚剤：大麻(【マリファナ】，【ハシッシュ】)',
      groups: [{ label: '', rows: [
        { term: '精神依存', desc: '【+】' },
        { term: '身体依存', desc: '【−】' },
        { term: '耐性', desc: '【−】' },
      ]}]
    },
  ]
},
{
  q: '①アヘン類は大量使用によって，【呼吸抑制】作用，【縮】瞳，心拍数減少をきたす．離脱症状はこの逆で，【散】瞳をはじめとする激しい【自律神経症状】が起きる（【自律神経の嵐】）．',
  s: 'U06', ch: 'その他の薬物依存',
},
{
  q: '②大麻類は【身体】依存がなく，使用を中止しても【離脱症状】は出現しない．耐性は生じ【ない】．',
  s: 'U06', ch: 'その他の薬物依存',
},
{
  q: '③コカインの慢性使用時にはコカイン幻覚症（アリ・シラミをみる【幻視】や幻触）が起きる．【身体】依存がないにも関わらず，【精神】依存による再使用率が極めて高い．耐性は生じ【ない】．',
  s: 'U06', ch: 'その他の薬物依存',
},
{
  q: '④タバコの離脱症状には【食欲亢進】，【体重増加】などがある．タバコ喫煙により摂取される物質のうち，【ニコチン】が主要な役割を果たす．',
  s: 'U06', ch: 'その他の薬物依存',
},
// U07 睡眠生理
{
  q: '①睡眠周期と脳波',
  s: 'U07', ch: '睡眠生理',
  type: 'grouped',
  categories: [
    {
      label: '覚醒',
      groups: [{ label: '', rows: [
        { term: '', desc: '【β】波（開眼時）' },
        { term: '', desc: '【α】波（閉眼時）' },
      ]}]
    },
    {
      label: 'ノンレム睡眠：睡眠段階1',
      groups: [{ label: '', rows: [
        { term: '', desc: '【α】波が消失して【θ】波が出現' },
      ]}]
    },
    {
      label: 'ノンレム睡眠：睡眠段階2',
      groups: [{ label: '', rows: [
        { term: '', desc: '【紡錘波】，【K複合波】が出現' },
      ]}]
    },
    {
      label: 'ノンレム睡眠：睡眠段階3',
      groups: [{ label: '', rows: [
        { term: '', desc: '20～50%が【δ】波（高振幅徐波）' },
      ]}]
    },
    {
      label: 'ノンレム睡眠：睡眠段階4',
      groups: [{ label: '', rows: [
        { term: '', desc: '50%以上が【δ】波（高振幅徐波）' },
      ]}]
    },
    {
      label: 'レム睡眠',
      groups: [{ label: '', rows: [
        { term: '', desc: '【θ】波，【β】波（睡眠段階1に類似）' },
      ]}]
    },
  ]
},
{
  q: '②身体は眠っているが脳は活動している（夢をみる）状態を【REM】睡眠，脳は眠っているが身体は起きかけている状態を【NREM】睡眠という．入眠後，REM睡眠は【増加】し，徐波睡眠（深睡眠）は【減少】する．',
  s: 'U07', ch: '睡眠生理',
},
{
  q: '③REM睡眠は新生児で【50】％程度であり，成長につれて【減少】し，成人で【20】％程度となる．',
  s: 'U07', ch: '睡眠生理',
},
{
  q: '④高齢者では徐波睡眠とREM睡眠が【減少】し，中途覚醒や早朝覚醒が【増加】する．',
  s: 'U07', ch: '睡眠生理',
},

// U07 不眠症
{
  q: '①不眠の原因は精神疾患や身体疾患，心理的要因，薬剤性など様々で，主に【浅眠】と【中途覚醒】，【早朝覚醒】，【入眠困難】，【熟眠困難】をきたす．',
  s: 'U07', ch: '不眠症',
},
{
  q: '②不眠症の治療は，【原疾患の治療】など原因に対処することが大切である．非薬物療法として，睡眠時間にこだわらず寝付けない時は【離床】すること，起床時間は【一定】にすること，起床後に【日光】を浴びることなどがある．',
  s: 'U07', ch: '不眠症',
},
{
  q: '③不眠症の薬物療法として【GABA】受容体作動薬（ベンゾジアゼピン系や非ベンゾジアゼピン系），【メラトニン】受容体作動薬，【オレキシン】受容体拮抗薬を用いる．一部の抗うつ薬や抗精神病薬を用いることもある．',
  s: 'U07', ch: '不眠症',
},

// U07 ナルコレプシー
{
  q: '①ナルコレプシーとは覚醒が維持できないことに加え，【REM睡眠】を抑制できない状態である．四主徴を認める．',
  s: 'U07', ch: 'ナルコレプシー',
  type: 'indent',
  rows: [
    { level: 0, text: '・日中の強い【眠気】と【睡眠発作】' },
    { level: 0, text: '・情動脱力発作（【カタプレキシー】）' },
    { level: 0, text: '・睡眠【麻痺】' },
    { level: 0, text: '・【入眠時幻覚】' },
  ]
},
{
  q: '②ナルコレプシーの検査所見として，【睡眠ポリグラフ】検査で入眠時の【REM】睡眠出現，睡眠潜時の【短縮】がみられる．日本人ではほぼ全例でHLA-【DR2】陽性である．',
  s: 'U07', ch: 'ナルコレプシー',
},
{
  q: '③ナルコレプシーの治療は中枢神経刺激薬（【メチルフェニデート】）や【三環系抗うつ】薬を用いる．',
  s: 'U07', ch: 'ナルコレプシー',
},

// U07 レストレスレッグス症候群
{
  q: '①レストレスレッグス症候群では安静時に【下肢】に異常感覚（【むずむず】感，虫が這う感じ）が起こり，【動かす】と改善する．【夜間】に悪化するため【入眠】が障害される．',
  s: 'U07', ch: 'レストレスレッグス症候群',
},
{
  q: '②レストレスレッグス症候群は【女】性に多く，【鉄欠乏性】貧血，【腎】不全，【妊娠】などに合併しやすい．入眠後の【周期性四肢運動】障害を合併することも多い．',
  s: 'U07', ch: 'レストレスレッグス症候群',
},
{
  q: '③レストレスレッグス症候群の治療に【ドパミン作動】薬（【プラミペキソール】），ベンゾジアゼピン系（クロナゼパム）を用いる．',
  s: 'U07', ch: 'レストレスレッグス症候群',
},
{
  q: '④周期性四肢運動障害では睡眠中に【四肢】の【不随意】運動が繰り返し起こり，【中途覚醒】が生じる．軽症例では症状が自覚されないことが多いが，重症例では【日中の眠気】や【倦怠感】を訴える．',
  s: 'U07', ch: 'レストレスレッグス症候群',
},
{
  q: '⑤周期性四肢運動障害は【高齢者】に多く，【鉄欠乏性】貧血や腎不全，神経変性疾患などに合併しやすい．【レストレスレッグス】症候群など，他の睡眠障害の合併も多い．治療は【ドパミン作動薬】（プラミペキソール）を用いる．',
  s: 'U07', ch: 'レストレスレッグス症候群',
},

// U07 睡眠時随伴症
{
  q: '①睡眠時遊行症・睡眠時驚愕症の特徴',
  s: 'U07', ch: '睡眠時随伴症',
  type: 'indent',
  rows: [
    { level: 0, text: '・睡眠時遊行症(夢遊病)：睡眠中に急に起き上がって徘徊した後，再び就寝する' },
    { level: 0, text: '・睡眠時驚愕症(夜驚症)：睡眠中に急に【大声で怯えて泣きわめく】' },
    { level: 0, text: '・両者とも【小児】に多く，入眠後【3】時間の【徐波】睡眠（【NREM】睡眠）で生じることが多い' },
    { level: 0, text: '・刺激によって覚醒せず，行動の記憶は【ない】．予後は【良く】，多くは【自然軽快】する' },
  ]
},
{
  q: '②REM睡眠行動障害は，REM睡眠時に夢の内容に従った【異常行動】がみられるものである．【高】齢【男】性に多く，【Lewy小体型】認知症や【Parkinson】病などの神経変性疾患の合併が多い．また，時間帯として，【明け方】に多い．刺激によって覚醒し，夢の内容は想起【可能】である．治療は【環境調整】，【クロナゼパム】である．',
  s: 'U07', ch: '睡眠時随伴症',

},
// U08 摂食障害
{
  q: '①摂食障害は【やせ願望】や【肥満恐怖】による食行動の障害で，【先進】国に多く，【若】年【女】性に好発する．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '②摂食障害は【神経性やせ症】（AN）と【神経性大食症】（BN）に分けられる．神経性やせ症の死亡率は【高】い．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '③神経性やせ症ではBMIが【18.5】未満の極端な痩せが見られ，【ボディイメージ】の障害，病識や低体重に対する深刻さの【欠如】，活動性の【亢進】がある．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '④神経性大食症は【むちゃ食い】エピソードと不適切な代償行為（自己誘発性【嘔吐】，【下剤】・【利尿剤】乱用）を繰り返す．体重は【保たれている】ことが多く病識は【ある】ことが多い．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '⑤摂食障害の身体所見',
  s: 'U08', ch: '摂食障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・血圧【↓】，【徐】脈，体温【↓】，正球性正色素性【貧血】' },
    { level: 0, text: '・第2度【無月経】：GnRH【↓】，LH・FSH【↓】，エストロゲン・プロゲステロン【↓】' },
    { level: 0, text: '・low T3症候群：【fT3↓】，rT3【↑】，fT4 →～↓，TSH【→～↓】' },
    { level: 0, text: '・低栄養による【Alb】↓' },
    { level: 0, text: '・低糖：インスリン【↓】，GH【↑】，尿ケトン体（【+】）' },
    { level: 0, text: '・骨密度の低下：Ca【↓】，P【↓】，Vit.D【↓】，Vit.K【↓】' },
    { level: 0, text: '・ストレス反応（HPA系亢進）：CRH【↑】，ACTH【↑】，CORT【↑】' },
    { level: 0, text: '・産毛の【増生】' },
    { level: 0, text: '・その他：Chol【↑】，脳萎縮など' },
  ]
},
{
  q: '⑥治療について，心身症として心身両面からの治療が必須となる．身体的には，エネルギー必要量に応じて【栄養】療法を行う．高度・長期の低栄養患者に実施する場合は，【refeeding】症候群や【Wernicke】脳症に注意する必要がある．また精神的には，支持的精神療法，認知行動療法などを行う．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '⑦refeeding症候群では，長期の低栄養状態に急激に【糖質】が流入することで低【P】・【K】・【Mg】血症などの電解質異常が生じ，心不全や呼吸不全，意識障害，肝機能障害など多彩な症状をきたす．最栄養は経口・経腸で【少量】から行い，高リスクの患者には【リン】を含む電解質，血糖値，心機能のモニタリングを行う．',
  s: 'U08', ch: '摂食障害',
},
{
  q: '⑧Wernicke脳症は【ビタミンB1】欠乏による急性～亜急性の中枢神経障害で，三徴として【意識障害】，【眼球運動障害】，【運動失調】がみられる．高リスクの患者にブドウ糖輸液や高カロリー輸液を行う場合は【ビタミンB1】を添加する．',
  s: 'U08', ch: '摂食障害',
},
// U09 自閉スペクトラム症
{
  q: '①自閉スペクトラム症は【乳幼児】期に発覚することが多く，【男】児に多い．原因は【先天】的な脳の障害と考えられている．',
  s: 'U09', ch: '自閉スペクトラム症',
},
{
  q: '②自閉スペクトラム症の症状',
  s: 'U09', ch: '自閉スペクトラム症',
  type: 'indent',
  rows: [
    { level: 0, text: '【社会】的コミュニケーション及び【対人】相互作用における持続的な欠陥' },
    { level: 1, text: '・【視線】を合わせない' },
    { level: 1, text: '・【人見知り】や【母親の後追い】がない' },
    { level: 1, text: '・【指差し】をしない' },
    { level: 1, text: '・同年代の子供に【興味を示さない】' },
    { level: 0, text: '行動・興味・活動の【限定】された【反復】的な様式' },
    { level: 1, text: '・特定の物事，儀式や習慣への強い【執着】' },
    { level: 1, text: '・【常同】行動' },
    { level: 1, text: '・【感覚過敏】，鈍麻' },
    { level: 0, text: '・また，【言語】的コミュニケーションの障害（【発語】の遅れ，【反響】言語）や，【多動】，【チック】などを伴うことがある．知的障害がみられることが多い．' },
  ]
},
{
  q: '③自閉スペクトラム症の治療は【心理社会的介入】（対人スキルの訓練，親へのサポートなど）がある．',
  s: 'U09', ch: '自閉スペクトラム症',
},

// U09 ADHD
{
  q: '①注意欠如多動性障害は【男】児に多く，主症状は【不注意】（集中困難），【多動】性，【衝動】性で，チックの合併が多い．原因は脳内の【ドパミン】及び【ノルアドレナリン】系の機能低下と考えられている．多動は年齢とともに比較的改善しやすいが，不注意は成人後も残存することが多い．',
  s: 'U09', ch: '注意欠如多動性障害（ADHD）',
},
{
  q: '②注意欠如多動性障害（ADHD）の治療は心理社会的介入が優先となる．薬物療法として【メチルフェニデート】（コンサータ®），アトモキセチンが用いられる．',
  s: 'U09', ch: '注意欠如多動性障害（ADHD）',
},

// U09 学習障害
{
  q: '①（限局性）学習障害は【男】児に多く，ある特定の領域（【読み】，【書き】，計算など）についての能力のみが明らかに低い状態である．知的には【正常範囲】であることが多い．治療は【心理社会的介入】を行う．',
  s: 'U09', ch: '（限局性）学習障害',
},

// U09 選択緘黙
{
  q: '①選択緘黙とは特定の生活領域でのみ【自発的な発語】が困難になる状態で，聴力や発声，言語理解は【正常】である．【幼児】期から発症し，小学校入学【後】に気づかれることが多い．無理にしゃべらせず，【心理社会的介入】を行う．',
  s: 'U09', ch: '選択緘黙',
},

// U09 チック症
{
  q: '①チック症のうち，突発的で急速な【不随意】運動を【運動チック】，発声を【音声チック】という．学童期の【男】児に多く，短時間であれば【自分で抑制でき】，睡眠中は【消失】しやすい．【リラックス】で出現し，【ストレス】や【精神的緊張】で増強する．治療は心理社会的介入を行うが，【自然軽快】することが多い．',
  s: 'U09', ch: 'チック症',
},
{
  q: '②Tourette症候群は運動チックと音声チックが複数合併し，1年以上継続して存在するものである．【汚言】症がみられる．【ADHD】，【強迫性】障害を合併することが多い．治療に心理社会的介入や【抗精神病】薬を用いる．',
  s: 'U09', ch: 'チック症',
},

// U09 その他
{
  q: '①行為障害（素行障害）とは【反社会】的，【攻撃】的，【反抗】的な行動パターンが反復して持続する障害（過度のけんか・いじめ，放火・盗みなど）．',
  s: 'U09', ch: 'その他の疾患',
},
{
  q: '②愛着障害とは，特殊な【養育環境】に起因する障害であり，【反応】性愛着障害と【脱抑制】性愛着障害に分けられる．',
  s: 'U09', ch: 'その他の疾患',
},
{
  q: '③【反応性】愛着障害は【虐待】など著しく不適切な療育によって【矛盾】した【両価的】な対人反応を示す．情緒反応の欠如や攻撃性などを認める．',
  s: 'U09', ch: 'その他の疾患',
},
{
  q: '④【脱抑制】性愛着障害は，乳児期より施設で育てられた子供などに見られ，【誰彼かまわず】愛着を向ける．',
  s: 'U09', ch: 'その他の疾患',
},
// U10 パーソナリティ障害
{
  q: '①パーソナリティ特性が平均から偏っているため，自分自身もしくは社会が悩むものをパーソナリティ障害という．DSM-5で10類型に分けられるが，臨床的に最も診断される頻度が高い型は【境界】性パーソナリティ障害である．',
  s: 'U10', ch: 'パーソナリティ障害',
},
{
  q: '②境界性パーソナリティ障害は【自己像】・【対人関係】・【感情】の不安定さ，著しい【衝動】性を特徴とする．',
  s: 'U10', ch: 'パーソナリティ障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・自己【同一】性の混乱' },
    { level: 0, text: '・【見捨てられ】不安，強い【依存】，【理想化】と【こき下ろし】' },
    { level: 0, text: '・【慢性】的な【空虚】感' },
    { level: 0, text: '・【自傷】行為' },
  ]
},
{
  q: '③境界性パーソナリティ障害は【気分】障害や【薬物】乱用，【摂食】障害の併存も多い．治療は長期の精神療法と薬物療法である．',
  s: 'U10', ch: 'パーソナリティ障害',
},

// U11 思考の異常
{
  q: '①思考の異常は，思考【内容】の異常，思考【過程】の異常（【思路】障害），思考の【体験様式】の異常の3つに分けられる．',
  s: 'U11', ch: '思考の異常',
},
{
  q: '②一次妄想とはその発生が了解【できない】ものであり，【統合失調症】の主症状の1つである．',
  s: 'U11', ch: '思考の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・妄想【知覚】：正常な知覚に対して，突然了解不能な意味づけをする' },
    { level: 0, text: '・妄想【着想】：何らかの動機や原因なく考え（着想）が浮かんできて，それを確信する' },
    { level: 0, text: '・妄想【気分】：周囲の世界が何となく変化してきて不気味に感じる．世界没落体験など' },
  ]
},
{
  q: '③二次妄想とは，その人の置かれた状況や感情などの背景を考慮すると発生を心理学的に了解【可能】なものをいう．',
  s: 'U11', ch: '思考の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・【被害】妄想(【統合失調症】に特徴的)：迫害妄想，被毒妄想，嫉妬妄想など' },
    { level: 0, text: '・【誇大】妄想(【双極性障害】の【躁状態】に特徴的)：発明妄想，宗教妄想，血統妄想，恋愛妄想' },
    { level: 0, text: '・【微小】妄想(【うつ病】に特徴的)：【罪業】妄想，【貧困】妄想，【心気】妄想' },
  ]
},
{
  q: '④思考過程の異常（思路障害）',
  s: 'U11', ch: '思考の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・【連合弛緩】(【統合失調症】に特徴的)：思考を構成する観念の間に意味の結びつきが乏しくなる' },
    { level: 0, text: '・【滅裂思考】(【統合失調症】に特徴的)：より関連性が弱くなり，話の内容が理解不能になったもの' },
    { level: 0, text: '・【言葉のサラダ】(【統合失調症】に特徴的)：更にひどくなって，無関係な言葉の羅列となったもの' },
    { level: 0, text: '・【観念奔逸】(【双極性障害】の【躁状態】に特徴的)：次々に考えが浮かび，思いつきで思考の方向がそれてしまうためまとまらない' },
    { level: 0, text: '・【思考制止】(【うつ病】に特徴的)：観念奔逸とは反対に思考が不活発になり，なかなか考えが浮かばず停滞する' },
    { level: 0, text: '・【思考途絶】(【統合失調症】に特徴的)：思考が途中で突然停止する' },
    { level: 0, text: '・【保続】(【前頭葉障害】に特徴的)：直前の反応を切り換えられないため思考が前に進まない' },
    { level: 0, text: '・【迂遠】(【老化】，【てんかん】に特徴的)：細部にまでこだわるため，要領よく思考目標に達せず，まわりくどい' },
  ]
},
{
  q: '⑤思考の体験様式の異常',
  s: 'U11', ch: '思考の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・【強迫思考】(【強迫性障害】に特徴的)：自分の意志に反して出現する不合理な観念，衝動，表像' },
    { level: 0, text: '・【させられ思考】(【統合失調症】に特徴的)：自分の思考であるのに，他者によって考えさせられていると体験するもの' },
    { level: 0, text: '・【思考吹入】(【統合失調症】に特徴的)：他者の考えが自分の中に入ってくるように体験するもの' },
  ]
},

// U11 知覚の異常
{
  q: '①知覚の異常は，単純な知覚異常と妄覚（【錯】覚，【幻】覚）に分けられる．【錯覚】は現実に存在するものを別のものとして知覚することで，【幻覚】は現実に実際に存在しないものを存在するように知覚することである．',
  s: 'U11', ch: '知覚の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・幻視(せん妄などの【意識障害】，【身体因性精神障害】に特徴的)：【小動物】幻視など' },
    { level: 0, text: '・幻聴(【統合失調症】に特徴的)：【考想化声】，話しかけと応答の形の幻聴，自己の行為に随伴して口出しする形の幻聴など' },
    { level: 0, text: '・幻嗅(【統合失調症】，【身体因性精神障害】に特徴的)：「生臭い匂いがする」など' },
    { level: 0, text: '・体感幻覚(【統合失調症】に特徴的)：「腸が溶けている」「頭の中で虫が動く」など' },
  ]
},

// U11 自我の異常
{
  q: '①自我の異常',
  s: 'U11', ch: '自我の異常',
  type: 'indent',
  rows: [
    { level: 0, text: '・【させられ体験】(【統合失調症】に特徴的)：自分の感情，思考，行動が何者かに操られているという体験' },
    { level: 0, text: '・【思考奪取】(【統合失調症】に特徴的)：自分の考えが抜き取られているという体験' },
    { level: 0, text: '・【思考伝播】(【統合失調症】に特徴的)：自分の考えが周囲に伝わってしまうという体験' },
    { level: 0, text: '・【思考吹入】(【統合失調症】に特徴的)：他者に考えを吹き込まれるという体験' },
    { level: 0, text: '・【自生思考】(【統合失調症】に特徴的)：考えが勝手に浮かんでくるという体験' },
    { level: 0, text: '・【離人症】(【統合失調症】，【うつ病】などに特徴的)：自分の身体，知覚や行動が自分のものという実感が乏しい' },
    { level: 0, text: '・【解離】(解離性健忘，解離性遁走，解離性同一性障害に特徴的)：意識，記憶，思考，感情，知覚，行動などが分断されて体験される' },
  ]
},

// U11 意識障害
{
  q: '①意識障害は単純な意識障害（意識【混濁】）と複雑な意識障害（意識【狭窄】，意識【変容】）に分けられる．',
  s: 'U11', ch: '意識障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・【せん妄】(【アルコール離脱時】に特徴的)：【動揺】を伴う意識混濁に幻覚や精神運動興奮，不安などを伴った意識変容状態' },
    { level: 0, text: '・【もうろう】状態(【てんかん】に特徴的)：意識【狭窄】に様々な意識混濁が加わり，幻覚や不安，徘徊などを伴った特殊な意識変容状態' },
  ]
},

// U11 意欲・行動の障害
{
  q: '①意欲・行動の障害',
  s: 'U11', ch: '意欲・行動の障害',
  type: 'indent',
  rows: [
    { level: 0, text: '・制止(【うつ病】に特徴的)：思考や談話，行動のテンポが【遅く】なった状態' },
    { level: 0, text: '・昏迷(【うつ病】，緊張型【統合失調症】，【解離性障害】に特徴的)：意識【清明】であるが，意志【発動】が全く行われなくなった状態' },
    { level: 0, text: '・途絶(【統合失調症】に特徴的)：思考や談話，行動が【突然停止】する状態' },
    { level: 0, text: '・緊張病症候群(緊張型【統合失調症】，【身体因性精神障害】，【うつ病】などに特徴的)：緊張病性興奮や緊張病性昏迷の他，【カタレプシー】や反響【動作】，反響【言語】，【常同】症などを認める' },
    { level: 0, text: '・無為(【統合失調症】に特徴的)：何も生産的なことを行わず，退屈も感じないこと' },
  ]
},
// U12 抗精神病薬
{
  q: '①抗精神病薬は【ドパミンD2受容体】を遮断する作用がある．',
  s: 'U12', ch: '抗精神病薬',
  type: 'grouped',
  categories: [
    {
      label: '定型抗精神病薬',
      groups: [{ label: '', rows: [
        { term: '主な薬物', desc: '【ハロペリドール】，クロルプロマジン，レボメプロマジン，ゾテピン' },
      ]}]
    },
    {
      label: '非定型：SDA（Serotonin-Dopamine Antagonist）',
      groups: [{ label: '', rows: [
        { term: '主な薬物', desc: '【リスペリドン】，パリペリドン，プロナンセリン，ペロスピロン，ルラシドン' },
      ]}]
    },
    {
      label: '非定型：MARTA（Multi-Acting Receptor Targeted Antipsychotics）',
      groups: [{ label: '', rows: [
        { term: '主な薬物', desc: '【オランザピン】，【クエチアピン】，クロザピン，アセナピン' },
      ]}]
    },
    {
      label: '非定型：DSS（Dopamine System Stabilizer）',
      groups: [{ label: '', rows: [
        { term: '主な薬物', desc: 'アリピプラゾール' },
      ]}]
    },
    {
      label: '非定型：SDAM（Serotonin-Dopamine Activity Modulator）',
      groups: [{ label: '', rows: [
        { term: '主な薬物', desc: 'ブレクスピプラゾール' },
      ]}]
    },
  ]
},
{
  q: '②抗精神病薬の副作用は，【錐体外路症状】（ジストニアやパーキンソニズムなど），【高プロラクチン血症】，高脂血症，高血糖，【無顆粒球】症，【悪性症候群】がある．',
  s: 'U12', ch: '抗精神病薬',
},
{
  q: '③抗精神病薬の適応は【統合失調症】，覚醒剤精神病，【せん妄】，【Tourette】症候群がある．',
  s: 'U12', ch: '抗精神病薬',
},

// U12 抗うつ薬
{
  q: '①抗うつ薬はシナプス間隙の【モノアミン濃度】を上昇させる作用がある．',
  s: 'U12', ch: '抗うつ薬',
  type: 'grouped',
  categories: [
    {
      label: '三環系抗うつ薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: '【イミプラミン】，【クロミプラミン】，アミトリプチリン，アモキサピン' },
      ]}]
    },
    {
      label: '四環系抗うつ薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ミアンセリン，マプロチリン' },
      ]}]
    },
    {
      label: 'SSRI',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: '【パロキセチン】，セルトラリン，エスシタロプラム，フルボキサミン' },
      ]}]
    },
    {
      label: 'SNRI',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'デュロキセチン，ベンラファキシン，ミルナシプラン' },
      ]}]
    },
    {
      label: 'NaSSA',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ミルタザピン' },
      ]}]
    },
    {
      label: 'S-RIM',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ボルチオキセチン' },
      ]}]
    },
  ]
},
{
  q: '②三環系抗うつ薬は副作用が多く，特に【心毒性】に注意する．SSRIやSNRIは投与初期に【消化器症状】をきたしやすい．NaSSAは眠気や食欲が【亢進】する．',
  s: 'U12', ch: '抗うつ薬',
},
{
  q: '③抗うつ薬は大うつ病や【神経症】（パニック障害，社交恐怖症，強迫性障害，全般性不安障害，PTSD）に用いられる．',
  s: 'U12', ch: '抗うつ薬',
},

// U12 気分安定薬
{
  q: '①気分安定薬',
  s: 'U12', ch: '気分安定薬',
  type: 'grouped',
  categories: [
    {
      label: '微量元素',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: '【炭酸リチウム】' },
      ]}]
    },
    {
      label: '抗てんかん薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: '【バルプロ酸ナトリウム】，【カルバマゼピン】，ラモトリギン' },
      ]}]
    },
  ]
},
{
  q: '②炭酸リチウムの副作用には【腎性尿崩症】，【振戦】，徐脈，催奇形性，甲状腺機能低下症，副甲状腺機能亢進症などがある．リチウム中毒では【消化器】症状や【中枢神経】症状をきたし，急性腎不全や【意識障害】，【けいれん】，死亡することがある．',
  s: 'U12', ch: '気分安定薬',
},
{
  q: '③バルプロ酸ナトリウムの副作用には催奇形性（【二分脊椎】），高アンモニア血症，肝障害などがある．',
  s: 'U12', ch: '気分安定薬',
},
{
  q: '④カルバマゼピンの副作用には【重症薬疹】や【無顆粒球症】，催奇形性がある．',
  s: 'U12', ch: '気分安定薬',
},
{
  q: '⑤ラモトリギンの副作用には【重症薬疹】がある．ラモトリギンは気分安定薬の中でも比較的安全性が高く，妊婦に使用することができる．',
  s: 'U12', ch: '気分安定薬',
},

// U12 抗不安薬
{
  q: '①抗不安薬の多くは【ベンゾジアゼピン】系であり，【GABAA】受容体に結合し抑制シグナルを増強する作用がある．抗不安作用の他に【催眠・鎮静】作用，【抗けいれん】作用，筋弛緩作用，健忘作用がある．',
  s: 'U12', ch: '抗不安薬',
  type: 'grouped',
  categories: [
    {
      label: 'ベンゾジアゼピン系：短時間型(≦6時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'クロチアゼパム，フタゾラム，エチゾラム' },
      ]}]
    },
    {
      label: 'ベンゾジアゼピン系：中間型(12〜24時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'アルプラゾラム，ロラゼパム，ブロマゼパム' },
      ]}]
    },
    {
      label: 'ベンゾジアゼピン系：長時間型(≧24時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'メダゼパム，【ジアゼパム】，クロキサゾラム' },
      ]}]
    },
    {
      label: 'ベンゾジアゼピン系：超長時間型(≧90時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ロフラゼプ酸エチル' },
      ]}]
    },
    {
      label: '5-HT1A受容体作動薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'タンドスピロン' },
      ]}]
    },
  ]
},
{
  q: '②抗不安薬の副作用には，【眠気】，【転倒】，一過性【前向性健忘】がある．',
  s: 'U12', ch: '抗不安薬',
},
{
  q: '③神経症性障害や【アルコール離脱症候群】などに用いられる．',
  s: 'U12', ch: '抗不安薬',
},
{
  q: '①睡眠薬',
  s: 'U12', ch: '睡眠薬',
  type: 'grouped',
  categories: [
    {
      label: 'GABAA受容体作動薬：ベンゾジアゼピン系・超短時間型(2〜4時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'トリアゾラム' },
      ]}]
    },
    {
      label: 'GABAA受容体作動薬：ベンゾジアゼピン系・短時間型(6〜10時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ブロチゾラム，ロルメタゼパム，リルマザホン' },
      ]}]
    },
    {
      label: 'GABAA受容体作動薬：ベンゾジアゼピン系・中時間型(20〜30時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ニトラゼパム，フルニトラゼパム，エスタゾラム' },
      ]}]
    },
    {
      label: 'GABAA受容体作動薬：ベンゾジアゼピン系・長時間型(30〜100時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'フルラゼパム，クアゼパム，ハロキサゾラム' },
      ]}]
    },
    {
      label: 'GABAA受容体作動薬：非ベンゾジアゼピン系・超短時間型(2〜4時間)',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ゾルピデム，ゾピクロン，エスゾピクロン' },
      ]}]
    },
    {
      label: '【メラトニン】受容体作動薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'ラメルテオン' },
      ]}]
    },
    {
      label: '【オレキシン】受容体拮抗薬',
      groups: [{ label: '', rows: [
        { term: '薬剤', desc: 'スボレキサント，レンボレキサント' },
      ]}]
    },
  ]
},
// U12 精神刺激薬
{
  q: '①メチルフェニデートは【ナルコレプシー】や【ADHD】に適応がある．副作用は食欲不振，体重減少，不眠，動悸などが挙げられる．【依存性が高い】ため注意が必要である．',
  s: 'U12', ch: '精神刺激薬',
},

// U13 認知機能検査
{
  q: '①認知機能検査には【改訂長谷川式簡易知能評価スケール】（HDS-R）とMini-Mental State Examination（【MMSE】）があり，いずれも対面で5～10分程度で施行でき，【認知症】のスクリーニングに有効である．',
  s: 'U13', ch: '認知機能検査',
},
{
  q: '②HDS-Rでは【20】点以下で認知症を疑う．MMSEでは【27】点以下で【軽度認知障害】（MCI），【23】点以下で認知症を疑う．',
  s: 'U13', ch: '認知機能検査',
},

// U13 性格検査
{
  q: '①【Rorschach】テストは【投影】法で行い，インクのシミでできた10枚の図版を被験者に見せ，何に見えるかを答えてもらう検査である．',
  s: 'U13', ch: '性格検査',
},
{
  q: '②文章完成テスト（SCT）は【投影】法かつ【自記】式で，未完成の文を被験者に提示し完成させてもらう検査である．',
  s: 'U13', ch: '性格検査',
},
{
  q: '③Minnesota多面人格検査（MMPI）は【質問紙】法で行い，550問の質問にYes/Noで答える検査である．',
  s: 'U13', ch: '性格検査',
},

// U13 知能検査・発達検査
{
  q: '①知能検査にはWechsler成人用知能検査（【WAIS-Ⅲ】），Wechsler児童用知能検査（【WISC-Ⅳ】），田中・Binet式知能検査がある．WAIS-Ⅲは16歳以上，WISC-Ⅳは【5】～【15】歳に用い，【知能指数】（IQ）を算出する．検査項目ごとに得点のばらつきを見ることで，【得意・不得意】を評価できる．田中・Binet式知能検査は2歳以降に用い，IQに加え【精神年齢】を知ることができる．',
  s: 'U13', ch: '知能検査・発達検査',
},
{
  q: '②発達検査である津守・稲毛式乳幼児精神発達検査は【0】～【7】歳が対象で，養育者に回答してもらう【質問紙】法で行う．【乳幼児】の【発達スクリーニング】に適している．',
  s: 'U13', ch: '知能検査・発達検査',
},

// U13 前頭葉・記憶検査
{
  q: '①前頭葉機能（特に【遂行機能】）検査には【ウィスコンシンカードソーティングテスト】（WCST），【前頭葉機能検査】（FAB）がある．',
  s: 'U13', ch: '前頭葉検査',
},
{
  q: '①記憶検査には【リバーミード行動記憶検査】（RBMT）があり，日常生活における近似記の検査を行う．実際の生活場面に近い課題を使用することが特徴である．',
  s: 'U13', ch: '記憶検査',
},

// U13 精神症状の評価
{
  q: '①簡易精神症状評価尺度（BPRS）は【対面】で行い，すべての精神疾患，特に【統合失調症】の症状評価に用いる．【Hamiltonうつ病評価尺度】（HAM-D）は【うつ病】の【重症度】を評価する．これらは【治療の効果判定】に用いることもある．',
  s: 'U13', ch: 'その他の精神症状の評価',
},
{
  q: '②【自記】式のスクリーニング検査に【Beck】のうつ病自己評価尺度（BDI），状態・特性不安検査（【STAI】）などがある．',
  s: 'U13', ch: 'その他の精神症状の評価',
},

// U14 精神保健福祉法
{
  q: '①入院形態',
  s: 'U14', ch: '精神保健福祉法',
  type: 'grouped',
  categories: [
    {
      label: '任意入院',
      groups: [{ label: '', rows: [
        { term: '精神保健指定医の診察', desc: '【不要】' },
        { term: '同意または緊急度', desc: '【患者本人】の同意を得られる' },
        { term: '知事への届け出', desc: '不要' },
        { term: '入院制限', desc: '【なし】' },
      ]}]
    },
    {
      label: '医療保護入院',
      groups: [{ label: '', rows: [
        { term: '精神保健指定医の診察', desc: '【1】名の診察' },
        { term: '同意または緊急度', desc: '【家族等】の同意を得られる(本人の同意を得られない)' },
        { term: '知事への届け出', desc: '10日以内' },
        { term: '入院制限', desc: '【なし】' },
      ]}]
    },
    {
      label: '応急入院',
      groups: [{ label: '', rows: [
        { term: '精神保健指定医の診察', desc: '【1】名の診察' },
        { term: '同意または緊急度', desc: '【緊急】を要するが，家族等の同意が得られない(本人の同意を得られない)' },
        { term: '知事への届け出', desc: '直ちに' },
        { term: '入院制限', desc: '【72時間】' },
      ]}]
    },
    {
      label: '措置入院',
      groups: [{ label: '', rows: [
        { term: '精神保健指定医の診察', desc: '【2】名の診察' },
        { term: '同意または緊急度', desc: '【自傷他害】のおそれあり' },
        { term: '権限', desc: '都道府県知事' },
        { term: '入院制限', desc: '【なし】' },
      ]}]
    },
    {
      label: '緊急措置入院',
      groups: [{ label: '', rows: [
        { term: '精神保健指定医の診察', desc: '【1】名の診察' },
        { term: '同意または緊急度', desc: '【自傷他害】のおそれが著しく緊急を要する' },
        { term: '入院制限', desc: '【72時間】' },
      ]}]
    },
  ]
},
{
  q: '②精神病棟入院患者に対する行動制限には外出制限，面会制限，電話制限，隔離，拘束がある．そのうち【12】時間を超える【隔離】と【拘束】は精神保健指定医のみが指示を出すことができる．',
  s: 'U14', ch: '精神保健福祉法',
},
{
  q: '③精神病棟入院患者に対し制限できないこと',
  s: 'U14', ch: '精神保健福祉法',
  type: 'indent',
  rows: [
    { level: 0, text: '・【信書】の発信・受信' },
    { level: 0, text: '・代理人である【弁護士】や人権を養護する行政職員との【面会】や【電話】' },
    { level: 0, text: '・【精神医療審査会】への【退院請求】・処遇改善請求' },
  ]
},
{
  q: '精神障害者の支援施設',
  s: 'U14', ch: '精神保健福祉法',
  type: 'grouped',
  categories: [
    {
      label: '相談',
      groups: [{ label: '', rows: [
        { term: '【保健所】(全国468ヶ所)', desc: '第一線で【相談】業務や訪問【指導】を行う' },
        { term: '【精神保健福祉センター】(全国69ヶ所)', desc: '【都道府県】単位でより専門的な相談業務や，【保健所】への技術指導・援助を行う．【精神医療審査会】に関する事務を行う' },
      ]}]
    },
    {
      label: '居住',
      groups: [{ label: '', rows: [
        { term: '【グループホーム】', desc: '日常生活に必要な支援を受けながら【共同生活】を送ることができる住居' },
      ]}]
    },
    {
      label: '通所',
      groups: [{ label: '', rows: [
        { term: '【デイケア】・ショートケア・ナイトケア', desc: '社会生活に必要な基本的な技術を身につけたり，生活リズムを整えたりするための【リハビリテーション】施設' },
      ]}]
    },
    {
      label: '訪問',
      groups: [{ label: '', rows: [
        { term: '【訪問看護】・【訪問診療】', desc: '医師や看護師が訪問して診療やケアを行う' },
      ]}]
    },
    {
      label: '就労',
      groups: [{ label: '', rows: [
        { term: '就労【移行】支援事業所', desc: '一般企業に雇用されることが可能と見込まれる場合に一定期間行われる就労に向けての訓練' },
        { term: '就労【継続】支援事業所(A型，B型)', desc: '一般企業に雇用されることが【困難】な場合に提供される，就労や生産活動の場' },
      ]}]
    },
  ]
},
]